import { primaryActionColor } from "../utils/constants";
import { AddFlex } from "./reusableStyles";

export const BoxedTabs = ({ selectedTabIndex, setSelectedTabIndex, tabs }) => {
  const getBorderRadius = (arrayLength, index) => {
    if (arrayLength === 1) {
      return "4px";
    }
    if (index === 0) {
      return "4px 0 0 4px";
    }
    if (index === arrayLength - 1) {
      return "0 4px 4px 0";
    }
    return "0px";
  };
  return (
    <AddFlex>
      {tabs.map((elem, index) => (
        <AddFlex
          padding="9px 20px"
          backgroundColor={selectedTabIndex === index && primaryActionColor}
          borderRadius={getBorderRadius(tabs.length, index)}
          onClick={() => setSelectedTabIndex(index, elem)}
          style={{
            color: selectedTabIndex === index ? "white" : primaryActionColor,
            fontSize: "13px",
            cursor: "pointer",
            borderLeft: `1px solid ${primaryActionColor}`,
            borderTop: `1px solid ${primaryActionColor}`,
            borderBottom: `1px solid ${primaryActionColor}`,
            borderRight:
              index === tabs.length - 1
                ? `1px solid ${primaryActionColor}`
                : "",
          }}
        >
          {elem.name}
        </AddFlex>
      ))}
    </AddFlex>
  );
};
